import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

interface LoadingState {
  activeRequests: number;
}

export const LoadingStore = signalStore(
  { providedIn: 'root' },
  withState<LoadingState>({ activeRequests: 0 }),
  withComputed(({ activeRequests }) => ({
    isLoading: computed(() => activeRequests() > 0),
  })),
  withMethods((store) => ({
    requestStarted() {
      patchState(store, (state) => ({ activeRequests: state.activeRequests + 1 }));
    },
    requestEnded() {
      patchState(store, (state) => ({ activeRequests: state.activeRequests - 1 }));
    },
  })),
);
